require.context("./fonts", true, /^\.\/.*$/, 'sync');
require.context("./images", true, /^\.\/.*$/, 'sync');

import "./scss/app.scss"
import "./js"